// One tool picker on an automation card ("Task tool (new tasks)", "Calendar",
// "Chat tool"), drawn from a row built in lib/toolsInUse.js. With two or more
// tools of that kind connected it is a dropdown: the ready ones can be picked,
// the others are greyed out with what is left to set up. With one it reads
// "Uses <tool>" beside the tool's logo; with none it says what to connect. A
// saved pick that cannot be used gets one sentence naming the tool in use.
import React from "react";
import ToolIcon from "./ToolIcon";
import { ToolDropdown } from "./AutomationToolPicker";

export default function ToolChoiceField({
  id,
  label,
  ariaLabel,
  help,
  row,
  onChange,
}) {
  const labelId = `${id}-label`;
  return (
    <div className="crField toolChoice" data-testid={id}>
      <div className="crFieldLabel" id={labelId}>
        {label}
      </div>
      {row.mode === "select" ? (
        <ToolDropdown
          value={row.value}
          options={row.options}
          onChange={onChange}
          placeholder={row.placeholder || "Select…"}
          ariaLabel={ariaLabel || label}
        />
      ) : (
        <div
          className={`toolChoice__value${
            row.mode === "single" ? "" : " toolChoice__value--hint"
          }`}
          aria-labelledby={labelId}
        >
          {row.mode === "single" && row.tool ? (
            <ToolIcon tool={row.tool} />
          ) : null}
          <span>{row.text}</span>
        </div>
      )}
      {help ? <div className="muted small">{help}</div> : null}
      {row.notice ? (
        <div className="small toolChoice__notice" role="status">
          {row.notice}
        </div>
      ) : null}
    </div>
  );
}
